import { render } from "./FancyboxItem.vue?vue&type=template&id=570ea04e&scoped=true"
import script from "./FancyboxItem.vue?vue&type=script&lang=js"
export * from "./FancyboxItem.vue?vue&type=script&lang=js"

import "./FancyboxItem.vue?vue&type=style&index=0&id=570ea04e&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570ea04e"]])

export default __exports__